import { render } from "./BaseCheckbox.vue?vue&type=template&id=440dec8e&scoped=true"
import script from "./BaseCheckbox.vue?vue&type=script&lang=js"
export * from "./BaseCheckbox.vue?vue&type=script&lang=js"

import "./BaseCheckbox.vue?vue&type=style&index=0&id=440dec8e&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-440dec8e"]])

export default __exports__